import { render, staticRenderFns } from "./gallery_decTw.vue?vue&type=template&id=67e4588a&scoped=true&"
import script from "./gallery_decTw.vue?vue&type=script&lang=js&"
export * from "./gallery_decTw.vue?vue&type=script&lang=js&"
import style0 from "./gallery_decTw.vue?vue&type=style&index=0&id=67e4588a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4588a",
  null
  
)

export default component.exports